import { useQuery } from '@tanstack/react-query'

import { fetchCampaignPerformanceSummary } from '@/lib/venue/campaignPerformanceApi'

export function campaignPerformanceSummaryQueryKey(venueId: string, params: { from: string; to: string }) {
  return ['venue', venueId, 'campaign-performance-summary', params] as const
}

/** 홍보 성과·비용 조회 화면 상단 요약 카드(#734 §1-2). */
export function useCampaignPerformanceSummary(
  venueId: string,
  params: { from: string; to: string },
  options: { enabled?: boolean } = {}
) {
  return useQuery({
    queryKey: campaignPerformanceSummaryQueryKey(venueId, params),
    queryFn: () => fetchCampaignPerformanceSummary(venueId, params),
    enabled: options.enabled ?? true,
  })
}
